"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setAuthTokenCookie = setAuthTokenCookie;
exports.setHaTaskTaxonomyTestCookie = setHaTaskTaxonomyTestCookie;

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _cookieUtils = _interopRequireDefault(require("../utils/cookieUtils"));

function setAuthTokenCookie(authToken) {
  if ((0, _isEmpty2.default)(authToken)) {
    return;
  } // Check if server set the cookie, if not add it here


  var r = /^(.*\.)?(angieslist\.com|angi\.com)/;

  if (process.env.IS_BROWSER && (process.env.NODE_ENV === 'development' || !r.test(location.hostname))) {
    var expireDate = new Date();
    expireDate.setYear(expireDate.getFullYear() + 1);

    _cookieUtils.default.setCookie('authToken', authToken, expireDate.toUTCString());
  }
} // HA Task Taxonomy Test
// This is a non-target, custom test with manual allocation and variation stored in a cookie


function setHaTaskTaxonomyTestCookie() {
  if (typeof window !== 'undefined') {
    var maybeHaTaskTaxonomyTestVariation = _cookieUtils.default.getCookie('haTaskTaxonomyTestTaxonomyName');

    if (!maybeHaTaskTaxonomyTestVariation) {
      var haTaskTaxonomyTestVariation = Math.random() <= 0.5 ? 'AdPlatform' : 'HaTask';

      _cookieUtils.default.setCookie('haTaskTaxonomyTestTaxonomyName', haTaskTaxonomyTestVariation);
    }
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/common/auth/authUtils.js
// module id = 3360
// module chunks = 25